import { render, staticRenderFns } from "./ComponentsBrands.vue?vue&type=template&id=3bac28d6"
import script from "./ComponentsBrands.vue?vue&type=script&lang=js"
export * from "./ComponentsBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports